export default {
    TITLE: "joonas.ninja hallintanäkymä",
    API_PATH: "/api"
}